import React from 'react';

import {Link} from '../../../../lib/routes';

import {linkClass} from './link-style';

type Props = {
	args: string[];
};

// {@wiki college-of-fochlucan, Коллегия Фохлукана}
export const WikiPlugin: React.FC<Props> = ({args}) => {
	const [id, ...rest] = args;
	const title = rest.join(', ') || id;
	return (
		<Link route="wikiArticle" params={{id}} title={title} className={linkClass('wiki')}>
			{title}
		</Link>
	);
};
